import { IFieldMetaData } from "./IField"

export interface IFamilyGroupManagementFormField {
  FamilyGroup: IFieldMetaData,
  CreatedDate: IFieldMetaData,
  UpdatedDate: IFieldMetaData,
  UpdatedBy: IFieldMetaData,
  ProductType: IFieldMetaData,
  LPFamilyGroupMix: IFieldMetaData,
  MLPFamilyGroupMix: IFieldMetaData,
  SerialControl: IFieldMetaData,
  SerialInputMask: IFieldMetaData,
  StrapTotes: IFieldMetaData
}

export const MANAGEMENTFIELDS: IFamilyGroupManagementFormField = {
  FamilyGroup: { name: "FamilyGroup", rules: { required: {}, alphanumeric: {}, charLength: { minLength: 3, maxLength: 60 } } },
  CreatedDate: { name: "createdDate", rules: [] },
  UpdatedDate: { name: "updatedDate", rules: [] },
  UpdatedBy: { name: "UpdatedBy", rules: [] },
  ProductType: { name: "ProductType", rules: { required: {} } },
  LPFamilyGroupMix: { name: "LPFamilyGroupMix", rules: {} },
  MLPFamilyGroupMix: { name: "MLPFamilyGroupMix", rules: {} },
  SerialControl: { name: "SerialControl", rules: {} },
  StrapTotes: { name: "StrapTotes", rules: {} },
  SerialInputMask: { name: "SerialInputMask", rules: { required: { validateOn: (value, formValues) => formValues.SerialControl !== "N" } } },
}

export const ERROR_MESSAGES = {
  required: "This field is required",
  alphanumeric: "Value should contain only /, -, space, numbers 0 to 9 , letter A to Z and letter a to z",
  duplicate: "Value already exists",
  charLength: (minLength: number, maxLength: number) => `This field should have minimum ${minLength} characters and maximum ${maxLength} characters`
}

export enum FormInputLevels {
  FamilyGroup = "Family Group",
  updatedBy = "Updated By",
  ProductType = "Product Group",
  LPFamilyGroupMix = "LP Family Group Mix",
  MLPFamilyGroupMix = "MLP Family Group Mix",
  SerialControl = "Serial Control",
  SerialInputMask = "Serial Input Mask",
  createdDate = "Created Date",
  updatedDate = "Updated Date",
   StrapTotes= "StrapTotes"
}

export interface IFamilyGroupManagementError {
  FamilyGroup: string | undefined,
  CreatedDate: string | undefined,
  UpdatedDate: string | undefined,
  UpdatedBy: string | undefined,
  ProductType: string | undefined,
  LPFamilyGroupMix: string | undefined,
  MLPFamilyGroupMix: string | undefined,
  SerialControl: string | undefined,
  SerialInputMask: string | undefined,
  StrapTotes: string | undefined
}

export const ProductTypeOptions = [
  { label: "AMB", value: "AMB" },
  { label: "FRZ", value: "FRZ" },
  { label: "PRD", value: "PRD" },
  { label: "CHL", value: "CHL" }
];

export const SerialControlOptions = [
  { label: "Inbound (I)", value: "I" },
  { label: "Outbound (O)", value: "O" },
  { label: "Full (F)", value: "F" },
  { label: "TraceIn/TraceOut (T)", value: "T" },
  { label: "None (N)", value: "N" },
];